import { FC } from 'react';

type Props = {
	className?: string;
};

const PancelEdit_01_Icon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M11.9825 5.3227L4.25011 13.0551C4.01988 13.2854 3.85654 13.5739 3.77757 13.8897L3 17L6.11027 16.2225C6.42616 16.1434 6.71464 15.9801 6.94488 15.7499L14.6773 8.01746M11.9825 5.3227L14.0422 3.2631C14.3929 2.9123 14.9617 2.9123 15.3125 3.2631L16.7369 4.68753C17.0877 5.03833 17.0877 5.60707 16.7369 5.95786L14.6773 8.01746M11.9825 5.3227L14.6773 8.01746'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinejoin='round'
			/>
			<path
				d='M9.73828 17H15.1278'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default PancelEdit_01_Icon;
